import { Button } from 'components/buttons/button';
import { inputClassNames, labelClassNames } from 'components/forms/input';
import { createEmptyState } from 'components/text-editor/editor-utils';
import { TextEditor } from 'components/text-editor/text-editor';
import { EditorState } from 'draft-js';
import {
  BlockData,
  BlockType,
  BlockTypeProps,
  ContentBlock,
  IContent,
} from './types';

interface Props extends BlockTypeProps<'key-value'> {
  keyLabel: string;
  valueLabel: string;
  hideTitle?: boolean;
}

export const KeyValueBlock = ({
  block,
  reducer,
  className,
  keyLabel,
  valueLabel,
  hideTitle,
}: Props) => {
  return (
    <section
      className={`${className} bg-white rounded border border-gray-200 px-4 py-4 flex flex-col`}>
      {!hideTitle && <h2 className='header'>{block.label}</h2>}
      <ul className='space-y-8'>
        {block.data.map((qa, i) => (
          <li className='flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8'>
            <div className='w-full'>
              <button
                className='mr-4 text-sm text-red-default hover:underline'
                onClick={(e) => {
                  e.preventDefault();
                  if (confirm('Are you sure?')) {
                    reducer({
                      type: 'modify',
                      payload: {
                        ...block,
                        data: block.data.filter((item) => item.key !== qa.key),
                      },
                    });
                  }
                }}>
                Remove
              </button>
              <label htmlFor={`question_${i}`} className={`${labelClassNames}`}>
                {keyLabel}
                <input
                  type='text'
                  name={`question_${i}`}
                  id={`question_${i}`}
                  className={inputClassNames}
                  value={qa.key}
                  onChange={(e) =>
                    reducer({
                      type: 'modify',
                      payload: {
                        ...block,
                        data: block.data.map((ob) =>
                          ob.key === qa.key
                            ? { key: e.target.value, value: ob.value }
                            : ob
                        ),
                      },
                    })
                  }
                />
              </label>
            </div>
            <div className='w-full'>
              <label
                className={`${labelClassNames} my-auto flex-shrink`}
                htmlFor={`answer_${i}`}>
                {valueLabel}
              </label>
              <TextEditor
                disableBooks
                disableEvents
                disableH2
                disableH3
                state={qa.value}
                setState={(newState) => {
                  reducer({
                    type: 'modify',
                    payload: {
                      ...block,
                      data: block.data.map((ob) =>
                        ob.key === qa.key
                          ? { key: ob.key, value: newState as EditorState }
                          : ob
                      ),
                    },
                  });
                }}
              />
            </div>
          </li>
        ))}
      </ul>
      <Button
        buttonType='secondary'
        buttonSize='lg'
        className='mx-auto mt-8'
        onClick={() => {
          reducer({
            type: 'modify',
            payload: {
              ...block,
              data: [...block.data, { key: '', value: createEmptyState() }],
            },
          });
        }}>
        Add
      </Button>
    </section>
  );
};
